<template>
  <!-- 关键词列表 -->
  <div>
    <div
      class="OptimizeTop"
      :class="{active: !isShowItem}"
      v-if="isFilter"
    >
      <div class="OptimizeTitle">已优化关键词</div>
      <div
        class="OptimizeItem"
        v-if="isShowItem"
      >
        <div class="optimize">
          <div class="iconfont">
            <ig-icon
              name="biaotiyouhua"
              class="biaotiyouhua"
            ></ig-icon>
          </div>
          <div class="right">
            <p><span>{{keywordstati.keywordCount}}</span>个关键词</p>
            <p>正在优化</p>
          </div>
        </div>
        <div class="create">
          <div class="iconfont">
            <ig-icon
              name="zongshushixin"
              class="zongshushixin"
            ></ig-icon>
          </div>
          <div class="right">
            <p><span>{{keywordstati.articleCount}}</span>篇文章</p>
            <p>总计生成</p>
          </div>
        </div>
      </div>
    </div>

    <filter-panel
      :data="groups"
      :hideResult="true"
      :simple="true"
      @search="filterChange"
      @change="change"
      v-if="!isFilter"
    ></filter-panel>
    <!-- 列表 -->
    <data-list
      :data="data"
      :columns="column"
      :page="page"
      :selection='selection'
      :page-size="page.pageSize"
      :tableStyle="{name: 'mixture'}"
      :isShowHeader="isShowHeader"
      :headerCellStyle="{background:'#ECF6FF'}"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
      @selection-change="selectionChange"
    ></data-list>
    <!-- 添加优化 -->
    <div
      class="add"
      v-if="isShowBtn"
    >
      <div class="checked">已选中：{{idsLength}}</div>
      <el-button
        class="button"
        type="primary"
        size="small"
        plain
        @click="delOptimize"
      >删除优化</el-button>
    </div>
  </div>
</template>

<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel.vue";
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";
import seo from "@/backend/services/seo/seoBoard.js";
const list = listPageCreate({
  searchConfig: {
    api: api.seo.optimizeKeywordList,
    method: "POST",
    config: {
      timeout: 30000
    }
  },
  getQuery(obj, that) {
    return _.assign(obj, { seoSiteId: that.$route.query.id });
  }
});
export default {
  mixins: [list],
  props: {
    column: Array,
    isShowItem: Boolean,
    isShowBtn: Boolean,
    groups: Object,
    selection: Boolean,
    isShowHeader: Boolean,
    isFilter: Boolean,
    isSEO: Boolean,
    idsLength: Number,
    keywordPlanning: false
  },
  data() {
    return {
      seoSiteId: "",
      keywordstati: "",
    };
  },
  methods: {
    change(item, value) {},
    // 多选事件
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    // 删除优化
    delOptimize() {
      this.$emit("delOptimize");
    },
    // 关键词统计
    async getkeywordstati() {
      this.seoSiteId = this.$route.query.id;
      let res = await seo.keywordstati(this.seoSiteId);
      this.keywordstati = res.data;
    }
  },
  components: { filterPanel },
  mounted() {
    // 关键词规划加载数据

    if (this.keywordPlanning) {
      this.query();
    }
    this.getkeywordstati();
  }
};
</script>

<style scoped lang='scss'>
.add {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .button {
    margin-left: 30px;
  }
}
.OptimizeTop {
  padding: 26px 30px 11px;
  .OptimizeTitle {
    font-size: 14px;
    font-weight: 700;
    color: #333;
  }
  .OptimizeItem {
    width: 400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .optimize,
    .create {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .iconfont .biaotiyouhua,
      .iconfont .zongshushixin {
        font-size: 20px;
        margin-right: 10px;
      }
      .iconfont .biaotiyouhua {
        color: #fdb933;
      }
      .iconfont .zongshushixin {
        color: #5dcbb0;
      }
      .right {
        font-size: 12px;
        color: #999;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #54a8fe;
          font-weight: bold;
          margin-right: 3px;
        }
        p {
          width: 100%;
        }
        p:nth-child(1) {
          margin-bottom: 5px;
        }
        p:nth-child(2) {
          color: #333;
        }
      }
    }
  }
}
.OptimizeTop.active {
  margin-bottom: 38px;
}

.has-gutter .el-table th,
.el-table tr {
  // background-color: red;
}
</style>
